import { FC } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import dayjs from 'dayjs';
import { IPainNrsMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: IPainNrsMetric | null;
  period?: string;
  height?: number;
}

export const PainNrsChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.series || data.series.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <LineChart data={data.series} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis
          domain={[0, 10]}
          label={{ value: 'NRS', angle: -90, position: 'insideLeft', fontSize: 11, fill: 'var(--c-text-1)' }}
          tick={chartAxisTick}
        />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(value) => [value, 'NRS']}
          labelFormatter={(label) => dayjs(label).format('DD/MM/YYYY')}
        />
        <Line
          type="monotone"
          dataKey="nrs"
          stroke="var(--ri-critical)"
          strokeWidth={2}
          dot={{ r: 3, fill: 'var(--ri-critical)' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
